import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"

export const Lock = (props: SvgProps) => (
  <Svg viewBox="0 0 51 51" {...props}>
    <Path
      d="M25.5 49C38.479 49 49 38.479 49 25.5S38.479 2 25.5 2 2 12.521 2 25.5 12.521 49 25.5 49Z"
      fill="currentColor"
      stroke="#fff"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M32.111 24.87H18.89A1.885 1.885 0 0 0 17 26.75v6.585c0 1.04.846 1.882 1.889 1.882H32.11A1.885 1.885 0 0 0 34 33.336v-6.585c0-1.039-.846-1.881-1.889-1.881Z"
      stroke="#fff"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M20.696 24.87v-3.943c0-1.306.506-2.56 1.407-3.484A4.744 4.744 0 0 1 25.5 16c1.274 0 2.496.52 3.397 1.443a4.992 4.992 0 0 1 1.407 3.484v3.943"
      stroke="#fff"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
)
